// Dependencies
import styled from 'styled-components';

const MenuStyles = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  width: 100%;
  height: 100%;
  pointer-events: ${(props) => (props?.open ? 'initial' : 'none')};

  .overlay {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) =>
      props?.open ? 'rgba(160, 152, 143, 0.9)' : 'rgba(160, 152, 143, 0)'};
    backdrop-filter: ${(props) => (props?.open ? 'blur(0.3rem)' : 'none')};
    transition: background-color 0.4s;
  }

  nav {
    display: flex;
    flex-direction: column;
    width: 90%;
    max-width: 35rem;
    height: 100%;
    margin-left: auto;
    padding: 5.938rem 2rem 5rem 2rem;
    background-color: #fff;
    transform: translateX(${(props) => (props?.open ? '0' : '100%')});
    transition: transform ease-in-out 0.4s;
    will-change: transform;
    overflow: auto;

    .close {
      position: absolute;
      top: ${(props) => (props?.scrolled ? '0.5rem' : '1rem')};
      right: 2.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3rem;
      height: 3rem;
      margin-left: auto;
      margin-right: -0.313rem;
      padding: 0.313rem;

      .icon {
        width: 1.25rem;
        transition: fill 0.4s;
      }

      &:hover,
      &:focus {
        .icon {
          fill: #000;
        }
      }
    }

    .primary {
      margin: 0 0 4rem;
      list-style: none;

      li {
        padding: 0.5rem 0;

        a {
          padding: 0.5rem 0;
          font-size: 1rem;
          font-weight: var(--font-weight-light);
          text-transform: uppercase;
          color: var(--color-charcoal);
          transition: color 0.4s;

          &:hover,
          &:focus {
            color: var(--color-charcoal);
          }
        }
      }
    }

    .social {
      display: flex;
      list-style: none;
      margin: auto 0 0 0;

      li {
        margin: 0 0.5rem;

        &:first-child {
          margin-left: -0.5rem;
        }

        a {
          padding: 0.5rem;

          .icon {
            width: 1.625rem;
            height: 1.625rem;
            transition: fill 0.4s;
          }

          &:hover,
          &:focus {
            .icon {
              fill: var(--color-charcoal);
            }
          }
        }
      }
    }
  }

  @media (min-width: 375px) {
    nav {
      padding: 5.938rem 4rem 5rem 4rem;
    }
  }

  @media (min-width: 768px) {
    nav {
      width: 45%;
      padding: 10rem 4rem 5rem 4rem;

      .close {
        top: ${(props) => (props?.scrolled ? '0.75rem' : '1.625rem')};
        right: 3.75rem;

        svg {
          width: 1.7rem;
        }
      }

      .primary {
        li {
          a {
            font-size: 1.25rem;
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    nav {
      width: 40%;
    }
  }

  @media (min-width: 1200px) {
    nav {
      width: 35%;
    }
  }
`;

export default MenuStyles;
